export const SORT_CARS_ARRAY = 'SORT_CARS_ARRAY';
export const SET_CATALOG_STYLE = 'SET_CATALOG_STYLE';
export const SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE';
export const SET_CAR_BRAND = 'SET_CAR_BRAND';
export const SET_CAR_MODEL = 'SET_CAR_MODEL';
export const SET_BODY_TYPE = 'SET_BODY_TYPE';
export const SET_PRODUCTION_YEAR_FROM = 'SET_PRODUCTION_YEAR_FROM';
export const SET_PRODUCTION_YEAR_TO = 'SET_PRODUCTION_YEAR_TO';
export const SET_TRANSMISSION_TYPE = 'SET_TRANSMISSION_TYPE';
export const SET_ENGINE_TYPE = 'SET_ENGINE_TYPE';
export const SEARCH_CARS = 'SEARCH_CARS';
export const SET_PRICE = 'SET_PRICE';
export const SHOW_CAR_CARDS = 'SHOW_CAR_CARDS';
